// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__34kDI","noInteraction":"EventWrapper_noInteraction__lni7a"};